import { render, staticRenderFns } from "./Configurator.vue?vue&type=template&id=1b5f9ffc&scoped=true"
import script from "./Configurator.vue?vue&type=script&lang=js"
export * from "./Configurator.vue?vue&type=script&lang=js"
import style0 from "./Configurator.vue?vue&type=style&index=0&id=1b5f9ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5f9ffc",
  null
  
)

export default component.exports